var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backend-container deal-share analytics-container"},[_c('BackendHeader'),_c('br'),_c('br'),_c('button',{on:{"click":function($event){return _vm.refreshIframe()}}},[_vm._v("REFRESH")]),_c('iframe',{ref:"iframe",attrs:{"src":"/ClickyAnalytics"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }